import type { FilterData } from '@which/shared'

import { get } from './get'

export const isFilterActive = (path: string, filterData: FilterData, value: string) => {
  const filters = get(filterData, path, [] as string[])
  return Array.isArray(filters) && filters?.includes(value)
}
